<template>
    <div class="update-discount-qualification">
      <div
        v-if="updateDiscount.showDiscountPage"
        class="workload-header">
        <v-layout
          row
          wrap
          align-center
          class="mx-3">
          <v-btn
            @click="goBackToList">Go Back</v-btn>
        </v-layout>
      </div>
      <formUserUpdateDiscountStep
            v-if="updateDiscount.showDiscountPage"
        />
      <div 
        v-if="!updateDiscount.showDiscountPage" 
        class="workload-data">
        <div
          class="workload-list mt-4 mx-3 pt-4">
          <material-card class="shutdown-box">
            <div class="headline black--text">
              <p class="shutdown-text">If this is  a Galaxy malfunction issues, please send an urgent email to  <a href="mailto:GuardiansoftheGalaxy@dxc.com">GuardiansoftheGalaxy@dxc.com</a>.</p>
              <p class="shutdown-text">If this is a registration issue related to funding, please send an urgent email to <a href="mailto:AWS-Oppreg@cloud.dxc.com">AWS-Oppreg@cloud.dxc.com</a></p>
            </div>
          </material-card>
          <material-card
            color="orange"
            title="Update Discount Qualification">
            <p class="title px-1 mb-2">This section enables you to only change the pricing qualification responses. As the submitter, your responses will be the attestation of these changes. If you need other edits to your submission, please email <a href="mailto:aws-oppreg@cloud.dxc.com">AWSOppreg Team</a>.<br />If your OPX is already associated with an existing DXC AWS account, you cannot use this feature as the DXC master payer, account name, etc will be impacted. Please reach out to the DXC account onboarding team (<a href="mailto:AWS-Account-OnBoarding@dxc.com">AWS-Account-OnBoarding@dxc.com</a>) to change a discount level on an existing DXC AWS Account..
            </p>
            <v-layout
                row
                wrap>
                <v-flex
                    md4
                    pt-2
                    ml-2>
                    <label>DXC SFDC Opportunity ID:</label>
                    <v-text-field
                        v-model.trim="updateDiscount.opportunityId"
                        solo
                        hide-details
                        placeholder="DXC SFDC OPPORTUNITY ID"
                        @keyup.enter="getDiscountRequestData"/>
                </v-flex>
                <v-flex
                    ml-3
                    md4
                    pt-4>
                    <v-btn
                        :loading="updateDiscount.searching"
                        color="success"
                        @click="getDiscountRequestData">Search</v-btn>
                </v-flex>
                <v-flex v-if="updateDiscount.accountRecordFound" md12 px-3 mb-3>
                    <span class="red--text">An Account exists for this OPX which is already associated with a Master Payer assigned by the discount qualification responses in Opportunity Registration. Please email <a href="mailto:AWS-Acount-Onboarding@dxc.com">AWS-Acount-Onboarding@dxc.com</a> to notify them you wish to change the Master Payer. After you address the master payer change with the Account Onboarding team , the Galaxy Oppreg team will be notified by the Account Onboarding team to manually align the new discount in the OPX record</span>
                </v-flex>
            </v-layout>
            <v-data-table
              :headers="filteredWorkloadHeaders"
              :items="updateDiscount.list"
              :pagination.sync="pagination"
              :loading="updateDiscount.searching"
              v-model="selected"
              item-key="Project_Id"
              disable-initial-sort
            >
  
              <!-- <template v-slot:no-data>
                <v-alert
                  v-if="!newOppRegistration.withError"
                  :value="true"
                  color="#000"
                  icon="info">
                  Loading Opportunity Registration Requests data...
                </v-alert>
                <v-alert
                  v-else-if="newOppRegistration.withError"
                  :value="true"
                  color="#000"
                  icon="warning">
                  No Opportunity Registration request found.
                </v-alert>
              </template> -->
  
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr >
                  <td>
                    <v-icon
                      small
                      title="View"
                      class="mr-2"
                      color="primary"
                      flat
                      @click="onDiscountChangePageOpen(props.item)">edit</v-icon>
                  </td>
                  <td>{{ props.item.OppReg_Id }}</td>
                  <td>{{ props.item.AWS_ACE_ID }}</td>
                  <td>{{ props.item.SFDC_Oppty_Name }}</td>
                  <td>{{ props.item.Workload_Title }}</td>
                  <td>{{ props.item.Workload_Status }}</td>
                  <td>{{ props.item.SFDC_Sales_Stage }}</td>
                  <td>{{ props.item.Workload_type }}</td>
                  <td>{{ props.item.Customer_Name }}</td>
                  <td>{{ props.item.Customer_Region }}</td>
                  <td>{{ props.item.Country }}</td>
                  <td>{{ props.item.SignDate }}</td>
                  <td>{{ props.item.WL_Q10A }}</td>
                  <td>{{ props.item.AWS_Notes}}</td>
                  <td>{{ props.item.Date_Created }}</td>
                </tr>
              </template>
            </v-data-table>
          </material-card>
        </div>
      </div>
      <v-snackbar v-model="updateDiscount.success" :bottom="true" :timeout="15000" color="orange">
        You have successfully updated the discount qualification
        <v-btn @click="updateDiscount.success = false" style="color: #000">Close</v-btn>
      </v-snackbar>
    </div>
  </template>
  <script>
  
  import { mapMutations, mapState, mapActions } from 'vuex'
  
  export default {
    $_veeValidate: { validator: 'new' },
    data () {
      return {
        // sfdcId: '',
        fromDateModal: false,
        endDateModal: false,
        from_date: '',
        to_date: '',
        Customer_Name: '',
        ESRegion: '',
        Workload_Status: '',
        ViewType: '',
        selected: [],
        showError: 'Unable to submit, please check Workload Statuses upon submission.',
        pagination: {
          descending: true,
          sortBy: 'Date_Created',
          page: 1,
          rowsPerPage: 10,
          totalItems: 0
        }
      }
    },
    mounted () {
         this.$store.commit('user/requestOppreg/resetUpdateDiscountPage')

    },
    computed: {
        ...mapState('user/requestOppreg', ['sfdcId', 'OppRegRequestHeaders', 'workloadList', 'newOppRegistration', 'updateDiscount']),
        filteredWorkloadHeaders () {
        return this.OppRegRequestHeaders
        },
    },
    methods: {
        ...mapMutations({
            showDiscountPage: 'user/requestOppreg/showDiscountPage',
            setDiscountId: 'user/requestOppreg/setDiscountId',
            setChangeLogRecord: 'setChangeLogRecord'
        }),

        onDiscountChangePageOpen (workload) {
            this.setDiscountId(workload.Registration_Id)
            this.showDiscountPage(true)

            let changeFrom = {}
            console.log(workload)
        
            let {Workload_type, Workload_Type_Date_Change, Attested_By_Date_2, Attested_By_Email_2, Attested_By_Manager_2, Attested_By_Title_2, Pricing_Tier_Qualification_2} = workload

            changeFrom = {
                Workload_type,
                Attested_By_Date_2,
                Attested_By_Email_2,
                Attested_By_Manager_2,
                Attested_By_Title_2,
                Pricing_Tier_Qualification_2,
                Workload_Type_Date_Change,
            }

            this.setChangeLogRecord({
                id: workload.Project_Id,
                changeFrom: changeFrom,
                module: 'oppreg',
                action: 'DiscountUpdate'
            },{ root: true }
            )
        },
        getDiscountRequestData () {
            this.$store.commit('user/requestOppreg/setAccountRecordFound', false)
            this.$store.dispatch('user/requestOppreg/getOppRegDiscountData', this.updateDiscount.opportunityId)
        },
        goBackToList () {
            this.$store.commit('user/requestOppreg/showDiscountPage', false)
        }
    }
  }
  
  </script>
  
  <style lang="scss" scoped>
  .shutdown-box {
    background-color: antiquewhite !important;
    margin-bottom: 35px !important;
  }
  .shutdown-text {
    font-size: 16px !important;
    font-weight: bold;
    color: #000 !important;
    margin-bottom: 0px !important;
  }
  </style>
  